export default __webpack_public_path__ + "static/media/appBanner.ceb33c26.webp";